var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"color":_vm.color,"fab":"","depressed":""}},[_c('v-icon',{attrs:{"color":"red lighten-2","large":""}},[_vm._v("mdi-share-variant")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }